export const DESCRICAO_SEM_METODO_PAGAMENTO = 'Você não possui nenhum método de pagamento ativo'

export const TITULO_CARD = 'Pagamento'
